__turbopack_context__.v({
  "articleType": "ArticlePublicationDate-module-scss-module__rHFDrW__articleType",
  "button": "ArticlePublicationDate-module-scss-module__rHFDrW__button",
  "expanded": "ArticlePublicationDate-module-scss-module__rHFDrW__expanded",
  "notUpdated": "ArticlePublicationDate-module-scss-module__rHFDrW__notUpdated",
  "publicationDate": "ArticlePublicationDate-module-scss-module__rHFDrW__publicationDate",
  "top": "ArticlePublicationDate-module-scss-module__rHFDrW__top",
});
